import type { ChangeEvent, ReactNode } from "react";

import { FormControlLabel, Switch as MuiSwitch, type SwitchProps as MuiSwitchProps } from "@mui/material";

import { cn } from "../../../utils/styling";

type SwitchProps = Omit<MuiSwitchProps, "onChange"> & {
  label?: ReactNode;
  labelClassName?: string;
  onChange?: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  switchClassName?: string;
};

const switchClassNames = cn(
  "[&_.MuiSwitch-switchBase.Mui-checked]:!text-lds-element-primary",
  "[&_.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track]:!bg-lds-element-primary",
  "[&_.MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track]:!opacity-100"
);

export const Switch = ({
  checked,
  className,
  label,
  labelClassName,
  onChange,
  switchClassName,
  ...props
}: SwitchProps) => {
  const control = (
    <MuiSwitch
      {...props}
      checked={Boolean(checked)}
      className={cn(switchClassNames, switchClassName)}
      onChange={(event, checkedValue) => onChange?.(checkedValue, event)}
    />
  );

  return (
    <FormControlLabel
      className={cn("!mx-0 !ml-0 max-w-full", className)}
      control={control}
      label={<span className={cn("font-ds-body-regular-md", labelClassName)}>{label}</span>}
    />
  );
};
